import React from 'react';
import {
  IconCircleNumber1Filled,
  IconCircleNumber2Filled,
  IconCircleNumber3Filled,
  IconCircleNumber4Filled,
} from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';

import { HowToRoot, HowToRow, HowToTitle } from './styles';

const STEPS = [
  { Icon: IconCircleNumber1Filled, key: 'checkout_payment_pix_how_to_1' },
  { Icon: IconCircleNumber2Filled, key: 'checkout_payment_pix_how_to_2' },
  { Icon: IconCircleNumber3Filled, key: 'checkout_payment_pix_how_to_3' },
  { Icon: IconCircleNumber4Filled, key: 'checkout_payment_pix_how_to_4' },
] as const;

type PixHowToListProps = {
  flush?: boolean;
};

export const PixHowToList = (props: PixHowToListProps) => {
  const { flush = false } = props;
  const { i18n } = useTranslate();

  return (
    <HowToRoot data-testid='pix-how-to-list' data-flush={String(flush)}>
      <HowToTitle>{i18n('checkout_payment_pix_how_to_title')}</HowToTitle>
      {STEPS.map(({ Icon, key }) => (
        <HowToRow key={key}>
          <Icon size={24} aria-hidden />
          <span>{i18n(key)}</span>
        </HowToRow>
      ))}
    </HowToRoot>
  );
};

export default PixHowToList;
